
import { NgModule } from '@angular/core';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuardService } from './services/auth-guard.service';
import { MenuItem } from './models/shared/menu-item.model';
import { PrivateLayoutComponent } from "./components/layout/private-layout.component";

import { ClientiListComponent } from './components/clienti/clienti-list.component';
import { ClienteDetailComponent } from "./components/clienti/cliente-detail.component";

import { BrogliacciListComponent } from "./components/brogliacci/brogliacci-list.component";
import { AccountLoginComponent } from "./components/account/account-login.component";
import { PublicLayoutComponent } from "./components/layout/public-layout.component";
import { PublicResetLayoutComponent } from "./components/layout/public-reset-layout.component";
import { PublicRichiestaLayoutComponent } from "./components/layout/public-richiesta-layout.component";
import { BrogliaccioDetailComponent } from "./components/brogliacci/brogliaccio-detail.component";
import { BrogliaccioNewDetailComponent } from "./components/brogliacci/brogliaccio-new-detail.component";
// import { DistinteIncassiListComponent } from "./components/distinteincassi/distinte-incassi-list.component";
// import { DistintaIncassiNewDetailComponent } from "./components/distinteIncassi/distinta-incassi-new-detail.component";
// import { DistintaIncassiDetailComponent } from "./components/distinteIncassi/distinta-incassi-detail.component";
import { DistinteVersamentiListComponent } from "./components/distinteVersamenti/distinte-versamenti-list.component";
import { DistintaVersamentiNewDetailComponent } from "./components/distinteVersamenti/distinta-versamenti-new-detail.component";
import { DistintaVersamentiDetailComponent } from "./components/distinteVersamenti/distinta-versamenti-detail.component";
import { AccountResetComponent } from "./components/account/account-reset.component";
import { AccountRichiestaResetComponent } from "./components/account/account-richiesta-reset.component";
import { AccountConfirmationExpiredComponent } from "./components/account/account-confirmation-expired.component";
import { UtentiListComponent } from './components/utenti/utenti-list.component';
import { ZoneUtenteListComponent } from './components/utenti/zone-utente-list.component';

import { DistintaAssegniDialog } from './components/incassi/distinta-assegni.component';
import { PublicConfirmExpiredLayoutComponent } from './components/layout/public-confirm-expired-layout.component';
import { HomepageManagerComponent } from './components/homepage-manager/homepage-manager.component';



const PUBLIC_ROUTES: Routes = [
  //{ path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'reset', component: AccountResetComponent },
  { path: 'richiestarecupero', component: AccountRichiestaResetComponent },
  { path: 'login', component: AccountLoginComponent},
  { path: 'accountconfirmexpired', component:AccountConfirmationExpiredComponent }
  
];

const PRIVATE_ROUTES: Routes = [
  { path: '',  component: DashboardComponent ,  canActivate: [AuthGuardService]},
  { path: 'clienti', component: ClientiListComponent,  canActivate: [AuthGuardService]},
  { path: 'clienti/:gid', component: ClienteDetailComponent,  canActivate: [AuthGuardService]},
  { path: 'brogliacci', component: BrogliacciListComponent,  canActivate: [AuthGuardService]},
  { path: 'brogliacci/:gid', component: BrogliaccioDetailComponent,  canActivate: [AuthGuardService]},
  { path: 'nuovobrogliaccio', component: BrogliaccioNewDetailComponent,  canActivate: [AuthGuardService]},
  // { path: 'distinteincassi', component: DistinteIncassiListComponent,  canActivate: [AuthGuardService]},
  // { path: 'nuovadistintaincassi', component: DistintaIncassiNewDetailComponent,  canActivate: [AuthGuardService]},
  // { path: 'distintaincassi/:gid', component: DistintaIncassiDetailComponent,  canActivate: [AuthGuardService]},
  { path: 'distinteversamenti', component: DistinteVersamentiListComponent,  canActivate: [AuthGuardService]},
  { path: 'nuovadistintaversamenti', component: DistintaVersamentiNewDetailComponent,  canActivate: [AuthGuardService]},
  { path: 'distintaversamenti/:gid', component: DistintaVersamentiDetailComponent,  canActivate: [AuthGuardService]},
  { path: 'utenti', component: UtentiListComponent,  canActivate: [AuthGuardService]},
  { path: 'profilo', component: ZoneUtenteListComponent,  canActivate: [AuthGuardService]},
  { path: 'gestione-homepage', component: HomepageManagerComponent,  canActivate: [AuthGuardService]},
  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

/*
const PRIVATE_ROUTES: Routes = [
  { path: '',  component: DashboardComponent },
  { path: 'clienti', component: ClientiListComponent},
  { path: 'clienti/:gid', component: ClienteDetailComponent},
  { path: 'brogliacci', component: BrogliacciListComponent},
  { path: 'brogliacci/:gid', component: BrogliaccioDetailComponent},
  { path: 'nuovobrogliaccio', component: BrogliaccioNewDetailComponent},
  { path: 'distinteincassi', component: DistinteIncassiListComponent},
  { path: 'nuovadistintaincassi', component: DistintaIncassiNewDetailComponent},
  { path: 'distintaincassi/:gid', component: DistintaIncassiDetailComponent},
  { path: 'distinteversamenti', component: DistinteVersamentiListComponent},
  { path: 'nuovadistintaversamenti', component: DistintaVersamentiNewDetailComponent},
  { path: 'distintaversamenti/:gid', component: DistintaVersamentiDetailComponent},
  { path: 'utenti', component: UtentiListComponent},
  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];*/

const mainRoutes: Routes = [
  { path: 'reset', component: PublicResetLayoutComponent },
  { path: 'richiestarecupero', component: PublicRichiestaLayoutComponent},
  { path: 'login', component: PublicLayoutComponent },
  { path: 'accountconfirmexpired', component: PublicConfirmExpiredLayoutComponent },
  //{ path: '', component: PublicLayoutComponent, children: PUBLIC_ROUTES },
  { path: '', component: PrivateLayoutComponent,  data: { title: 'Secure Views' }, children: PRIVATE_ROUTES }

];

@NgModule({
  imports: [
    RouterModule.forRoot(mainRoutes
     
     // ,{enableTracing:true}
    )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/app-routing.module.ts